import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client';
import type { LogLine, LogLevel } from './types';

interface LogQuery {
  tenant_id?: string;
  workspace_id?: string;
  level?: LogLevel[];
  q?: string;
  since?: string;
  limit?: number;
}

function buildParams(query: LogQuery): string {
  const p = new URLSearchParams();
  if (query.tenant_id) p.set('tenant_id', query.tenant_id);
  if (query.workspace_id) p.set('workspace_id', query.workspace_id);
  for (const l of query.level ?? []) p.append('level', l);
  if (query.q) p.set('q', query.q);
  if (query.since) p.set('since', query.since);
  if (query.limit) p.set('limit', String(query.limit));
  const s = p.toString();
  return s ? `?${s}` : '';
}

export function useLogs(query: LogQuery, options?: { live?: boolean }) {
  return useQuery({
    queryKey: ['logs', query],
    queryFn: () => apiFetch<LogLine[]>(`/logs${buildParams(query)}`),
    staleTime: options?.live ? 0 : 15_000,
    refetchInterval: options?.live ? 2_000 : false,
  });
}
